
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	modoTelaChecklist: 'lista',
	filtro: {
		com_previsao_saida: true,
		passa_na_matriz: true,
		deslocamento_patio: false,
		reingresso: false,
		impresso: true,
		nao_impresso: true,
		data_inicial_historico: DateFormat.getDataAnterior(30),
		data_final_historico: DateFormat.getDataAtual(),
		periodo_historico: 'datahora_entrada',
		pendenteExecucao: true,
		executando: true,
		aguardandoChegadaExecucao: true,
		executandoExecucao: true,
		finalizadoExecucao: true
	},
	lista: [],
	listaLog: [],
	listaStatus: [
		{ id: 1, nome: 'Aguardando Entrada' },
		{ id: 2, nome: 'No Pátio' },
		{ id: 3, nome: 'Aguardando Saída' },
	],
	listaMotorista: [],
	listaCavalo: [],
	listaCarreta: [],
	listaExecucao: [],
	listaChecklist: [],
	listaPortaria: [],
	listaHistorico: [],
	listaManutencaoSugestoes: [],
	listaRumo: [
		{ id: 'RN', valor: 'RN' },
		{ id: 'RS', valor: 'RS' },
		{ id: 'NAC', valor: 'Nacional' }
	],
	listaAtraso: [
		{ id: 'adiantado', valor: 'Adiantado' },
		{ id: 'atrasado', valor: 'Atrasado' }
	]
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'CONTROLE_PATIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'CONTROLE_PATIO_MODO_TELA_CHECKLIST':
            return { ...state,
				modoTelaChecklist: action.payload.modo,
				registroChecklist: action.payload.registro
			};

		case 'CONTROLE_PATIO_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'CONTROLE_PATIO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'CONTROLE_PATIO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'CONTROLE_PATIO_LOG_LISTADO':
			return {
				...state,
				listaLog: action.payload.data
			}
		
		case 'CONTROLE_PATIO_EXECUCAO_LISTADO':
            return {
				...state,
				listaExecucao: action.payload.data
			};

		case 'CONTROLE_PATIO_PORTARIA_LISTADO':
            return {
				...state,
				listaPortaria: action.payload.data
			};

		case 'CONTROLE_PATIO_HISTORICO_LISTADO':
            return {
				...state,
				listaHistorico: action.payload.data
			};

		case 'CONTROLE_PATIO_MOTORISTA_SELECT_LISTADO':
            return {
				...state,
				listaMotorista: action.payload.data
			};

		case 'CONTROLE_PATIO_PLACA_SELECT_LISTADO':
            return {
				...state,
				listaCavalo: action.payload.data.filter(item => item.tracao).map(item => ({ id: item.placa, valor: item.placa })),
				listaCarreta: action.payload.data.filter(item => !item.tracao).map(item => ({ id: item.placa, valor: item.placa }))
			};

		case 'CONTROLE_PATIO_CHECKLIST_LISTADO':
            return {
				...state,
				listaChecklist: action.payload.data
			};

		case 'CONTROLE_PATIO_MANUTENCAO_SUGESTOES_LISTADO':
            return {
				...state,
				listaManutencaoSugestoes: action.payload.data
			};

        default:
            return state;
    }
}
